// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.tracking.RentalManagerUserTrackingV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerUserTrackingEvent,
  UserTrackingEventV2RequestDto,
  UserTrackingListingV2RequestDto,
  UserTrackingLogV2RequestDto,
} from '../..';

interface HasSeenFeatureTourParams {
  featureTourTrackingEvent: RentalManagerUserTrackingEvent;
}

export const RentalManagerUserTrackingV2WebApiHandler_event_Path = '/api/web/v2/users/tracking/event';

/**
 * Track event
 */
export const RentalManagerUserTrackingV2WebApiHandler_event = (
  postData: UserTrackingEventV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserTrackingEventV2RequestDto, void>(
    {
      endpoint: RentalManagerUserTrackingV2WebApiHandler_event_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour_Path =
  '/api/web/v2/users/tracking/hasSeenFeatureTour';

/**
 * Check if a user has seen a feature tour
 */
export const RentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour = (
  getParams: HasSeenFeatureTourParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSeenFeatureTourParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserTrackingV2WebApiHandler_listing_Path = '/api/web/v2/users/tracking/listing';

/**
 * Track listing event
 */
export const RentalManagerUserTrackingV2WebApiHandler_listing = (
  postData: UserTrackingListingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserTrackingListingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserTrackingV2WebApiHandler_listing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserTrackingV2WebApiHandler_log_Path = '/api/web/v2/users/tracking/log';

/**
 * Log events for debugging purposes
 */
export const RentalManagerUserTrackingV2WebApiHandler_log = (
  postData: UserTrackingLogV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserTrackingLogV2RequestDto, void>(
    {
      endpoint: RentalManagerUserTrackingV2WebApiHandler_log_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
